<template>
  <div>
    <b-row>
      <b-col md="6">
        <b-form-group :class="{'error-input' : $v.data_layer.name.$error}">
          <label>Name*</label>
          <j-input
            v-model="$v.data_layer.name.$model"
            :max-length="50"
            placeholder="Position Layer Name"/>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :class="{'error-input' : $v.data_layer.code.$error}">
          <label>Code*</label>
          <j-input
            v-model="$v.data_layer.code.$model"
            :max-length="50"
            placeholder="Code"/>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :class="{'error-input' : $v.data_layer.parent.$error}">
          <label>Parent Layer</label>
          <j-single-select
            v-model="$v.data_layer.parent.$model"
            :is-async="true"
            :load-options="loadOptionsParent"
            placeholder="Select Parent"
            value-format="object"
            label="Parent"
            search-prompt-text="Type minimum 3 characters to search..."/>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// eslint-disable-next-line
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';

export default {
  validations: {
    data_layer: {
      name: { required },
      code: { required },
      parent: { },
    },
  },
  props: {
    mode: {
      type: String,
      default: 'create',
    },
  },
  data() {
    return {
      data_layer: {
        id: 0,
        name: '',
        code: '',
        parent: null,
      },
    };
  },

  computed: {
    ...mapState('jStoreLayer', ['layer_detail']),
  },
  watch: {
    layer_detail(newVal) {
      const detailLayer = {
        id: newVal.id,
        name: newVal.name,
        code: newVal.code,
        parent: null,
      };

      if (Object.keys(newVal.parent).length > 0 && newVal.parent.constructor === Object) {
        detailLayer.parent = { id: newVal.parent.id, label: newVal.parent.name };
      }

      this.data_layer = detailLayer;
    },
  },
  created() {
    if (this.mode === 'update') {
      this.modeUpdate();
    }
  },
  methods: {
    ...mapActions('jStoreLayer', ['getDetailLayer']),

    loadOptionsParent({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: '',
              ascending: true,
              query: searchQuery,
              query_type: 'name',
            },
          };
          this.$store.dispatch('jStoreLayer/getListParent', { reqData, callback, label: (this.filter ? this.filter : 'name') });
        } else {
          callback(null, false);
        }
      }
    },

    // validate form
    save() {
      this.$v.data_layer.$touch();
      if (!this.$v.data_layer.$error) {
        this.$emit('data', this.data_layer);
      } else {
        this.$emit('data', null);
      }
    },

    modeUpdate() {
      const req = {
        id: Number(this.$route.params.id),
      };
      this.getDetailLayer(req);
    },

    // generateDataEdit(data) {
    //   const dataDetail = {
    //     id: data.id,
    //     name: data.name,
    //     code: data.code,
    //     layer_head_id: data.parent.id,
    //   };
    //   return dataDetail;
    // },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/layer/jLayerForm.vue